<template>
	<div class="d-flex justify-content-end align-items-center">
		<!-- <h2 style="padding-top: 30px; padding-bottom: 0px; margin-bottom: 15px">Earthquake Map</h2>
		<div class="ml-auto pt-3">
			<a class="mr-3 cursor-pointer" @click="lngcode = 'sq'">SQ</a>
			<a class="mr-3 cursor-pointer" @click="lngcode = 'en'">EN</a>
			<a class="mr-3 cursor-pointer" @click="toggleList()"><i class="fal fa-list"></i></a>
			<a class="cursor-pointer" @click="toggleLegends()"><i class="fas fa-table"></i></a>
		</div> -->
	</div>
	<div class="row equal-height-blocks">
		<GeoMap @selected="selectItem" />
		<ListaMap @selected="selectItem" />
	</div>
</template>

<script>
import GeoMap from './Map.vue';
import ListaMap from './listajson.vue';
import axios from 'axios';
import languages from '../assets/language.js';
const GetURL =
	window.earthquakeconfig && window.earthquakeconfig.getdataurl
		? window.earthquakeconfig.getdataurl
		: process.env.VUE_APP_GET_URL;
export default {
	name: 'MainContainer',
	components: {
		GeoMap,
		ListaMap
	},
	data() {
		return {
			Mapdata: [],
			selected: null,
			lngcode:
				window.earthquakeconfig && window.earthquakeconfig.lngcode ? window.earthquakeconfig.lngcode : 'sq',
			languages: languages,
			isShow: true,
			showLegend: true,
			getJSONURL: GetURL,
			period: window.earthquakeconfig && window.earthquakeconfig.period ? window.earthquakeconfig.period : '1'
		};
	},
	watch: {
		period() {
			this.loadData();
		}
	},
	created() {
		this.loadData();
		this.lngcode =
			window.earthquakeconfig && window.earthquakeconfig.lngcode ? window.earthquakeconfig.lngcode : 'sq';
		//console.log(window.earthquakeconfig);
	},
	computed: {
		lang() {
			return this.languages[this.lngcode];
		}
	},
	methods: {
		selectItem(id) {
			this.selected = id;
		},
		toggleLegends() {
			this.showLegend = !this.showLegend;
			//console.log(this.showLegend);
		},
		toggleList() {
			this.isShow = !this.isShow;
		},
		loadData() {
			let axiosConfig = {
				headers: {
					'Content-Type': 'application/json'
				},
				params: {
					period: this.period
				}
			};
			axios.get(this.getJSONURL, axiosConfig).then((res) => {
				this.Mapdata = res.data.features;
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cursor-pointer {
	cursor: pointer;
}
</style>
